<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>鲸选钟点工列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="订单编号">
          <el-input v-model="listQuery.orderNo" placeholder="请输入订单编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input v-model="listQuery.itemName" placeholder="请输入商品名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="客户手机号">
          <el-input v-model="listQuery.customerPhone" placeholder="请输入客户手机号" clearable></el-input>
        </el-form-item>
        <el-form-item label="支付时间">
          <el-date-picker v-model="listQuery.payTime" type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="listQuery.status" placeholder="请选择状态" clearable>
            <el-option v-for="(item,index) in statusList" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="query">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data=listData border style="width: 100%" class="table">
        <div class="marker">客户需求明细数据</div>
        <el-table-column prop="id" width="50px" fixed="left" type="expand">
          <template slot-scope="scope">
            <el-table :data="scope.row.demandCollectDTOList">
              <el-table-column prop="createTime" label="创建时间"></el-table-column>
              <el-table-column prop="createName" label="创建人姓名"></el-table-column>
              <el-table-column label="收集完成时间" prop="finishTime">
              </el-table-column>
              <el-table-column prop="remark" label="备注"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" size="small"
                             @click="queryCollectDetail( scope.row.detail)">查看需求详情
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="jxOrderNo" label="订单编号"></el-table-column>
        <el-table-column prop="itemName" label="商品名称"></el-table-column>
        <el-table-column prop="payTime" label="支付时间"></el-table-column>
        <el-table-column prop="status" label="订单状态">
          <template slot-scope="scope">
            <span>{{ formatStatus(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="customerName" label="客户姓名"></el-table-column>
        <el-table-column prop="customerMaskPhone" label="客户手机号"></el-table-column>
        <el-table-column prop="customerAddr" label="客户地址"></el-table-column>
        <el-table-column prop="customerSource" label="客户来源">
          <template slot-scope="scope">
            <span>{{ formatSource(scope.row.customerSource) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="serviceModel" label="服务模式">
          <template slot-scope="scope">
            <span>{{ formatServiceModel(scope.row.serviceModel) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="syncOrder( scope.row.id)">同步订单状态</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize"
                  @pagination="query"/>
    </el-card>
    <el-dialog :visible.sync="showItemDetail" width="40%" :show-close=true title="需求详情" @close="closeDialog">
        <div>
           <p class="service-title">期望首次服务时间:{{demandDetail.firstDate}}</p>
           <p class="service-title">服务频次:{{demandDetail.serviceTimes}}</p>
           <p class="service-title">休息日:
             {{demandDetail.serviceTimes=='做五休二'?demandDetail.restDay.join(','):demandDetail.restDay}}
             </p>
           
           <div v-for="(item,index) in demandDetail.serviceContent" :key="index">
                <div class="demand-title">{{item.question_name}}{{item.isMark?'（重点关注）':''}}</div>
                <div v-for="(item1,index1) in item.children" :key="index1"> 
                 <span>{{item1.question_name}}:</span> 
                 <span v-if="item1.write_type!=3&&item1.result">{{item1.result.question_name}}</span> 
                <span v-if="item1.result">
                 <span v-if="item1.result.write_type==3">{{item1.remark}}</span> 
                 </span>
                 <span v-if="item1.write_type==3&&item1.result">{{item1.result}}</span> 
                </div>
           </div>


        </div>
        
        
         <span slot="footer" class="dialog-footer">
                <el-button @click="showItemDetail = false">关闭</el-button>
            </span>
          
    </el-dialog>

  </div>
</template>
<script>
import moment from "moment";
import Pagination from "../common/Pagination";
import service from "@/script/api/workercrmapi";

let vm;
export default {
  components: {Pagination},
  data() {
    return {
      total: 0,
      listQuery: {
        status: "",
        orderNo: "",
        itemName: "",
        customerPhone: "",
        payTime: [],
        pageNum: 1,
        pageSize: 20,
      },
      listData: [],
      statusList: {
        "1": "已支付",
        "2": "匹配中",
        "3": "服务中",
        "4": "已退款",
        "5": "服务已完成",
        "6": "服务已过期"
      },
      sourceList: {
        "1": "盒马",
        "2": "其他"
      },
      serviceModelList: {
        "1": "保姆",
        "2": "保洁",
      },
      showItemDetail: false,
      demandDetail:{
         firstDate:'',
         serviceTimes:'',
         restDay:'',
         serviceContent:[]
      },
    };
  },

  created() {
    this.query();
  },
  methods: {
    query() {
      this.listQuery.payTime == null ? this.listQuery.payTime = [] : this.listQuery.payTime;
      let startTime = this.listQuery.payTime[0];
      let endTime = this.listQuery.payTime[1];
      let param = {
        pageNum: this.listQuery.pageNum,
        pageSize: this.listQuery.pageSize,
        status: this.listQuery.status,
        orderNo: this.listQuery.orderNo,
        itemName: this.listQuery.itemName,
        customerPhone: this.listQuery.customerPhone,
        startTime: startTime ? moment(startTime).format("YYYY-MM-DD") : "",
        endTime: endTime ? moment(endTime).format("YYYY-MM-DD") : "",
      }
      service.$axiosGetJxOrderList(param).then((res) => {

        if (res.data.errno == 0) {
          this.total = res.data.data.total;
          this.listData = res.data.data.list;
          let s = this.listData.map(a => a.demandCollectDTOList);
          console.log(s);
        }
      });
    },
    formatStatus(status) {
      return this.statusList[status];
    },
    formatSource(source) {
      return this.sourceList[source];
    },
    formatServiceModel(serviceModel) {
      return this.serviceModelList[serviceModel];
    },
    queryCollectDetail(row) {
      console.log("row==>" + JSON.stringify(row));
      this.showItemDetail = true;
      //解析json todo
      let demandDetail=JSON.parse(row);
      this.demandDetail=demandDetail;
      console.log(demandDetail);
    },
    closeDialog() {
      this.showItemDetail = false;
    },
    syncOrder(orderId) {
      console.log("wait sync orderId===>" + orderId);
      let param = {
        orderId: orderId
      }
      service.$axiosRefreshOrderStatus(param).then(res => {
        if (res.data.errno == 0) {
          this.$message({
            message: '同步成功',
            type: 'success'
          });
          this.query();
        } else {
          this.$message({
            message: res.data.errmsg,
            type: 'error'
          });
        }
      }).catch(err => {
        this.$message({
          message: "同步失败，请稍后重试",
          type: 'error'
        });
      })
    },
  }
  ,
  beforeCreate() {
    vm = this;
  }
  ,
}
;
</script>
<style scoped>
.service-title{
  font-size: 15px;
  line-height: 32px;
}
.demand-title{
  line-height: 36px;
  font-weight: bold;
  font-size: 16px;
  margin-top:10px;
}
</style>
